export default "__VITE_ASSET__df4d0094__"